import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, PlatformLocation } from '@angular/common';
import { Router } from '@angular/router';

/**
 * Detects whether the current page was loaded with ?utm_source=rei.
 *
 * On detection in the browser the param is immediately stripped via Router.navigate()
 * so Angular's router state (ActivatedRoute) is updated — this prevents QueryParamDirective
 * from appending utm_source=rei to outbound links.
 * SSR always returns false so the eyebrow is never cached by CloudFront.
 */
@Injectable({
  providedIn: 'root',
})
export class ReiReferralService {
  private readonly REI_QUERY_PARAM = 'utm_source';
  private readonly REI_QUERY_VALUE = 'rei';

  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private readonly platformLocation = inject(PlatformLocation);
  private readonly router = inject(Router);

  readonly eyebrowLabel = "Welcome Real Estate Institute Customers, you're in the right place.";

  readonly logoSrcDark =
    'https://xgrit-ecom.imgix.net/v3_images/transforms/_323x190_crop_center-center_none/rei_by_ace.svg?v=1772733678';

  readonly logoSrcLight =
    'https://xgrit-ecom.imgix.net/v3_images/transforms/_323x190_crop_center-center_none/rei_by_ace_light.svg?v=1772746833';

  isReiReferred(): boolean {
    if (!this.isBrowser) {
      return false;
    }

    const params = new URLSearchParams(this.platformLocation.search);
    const detected = params.get(this.REI_QUERY_PARAM) === this.REI_QUERY_VALUE;

    if (detected) {
      void this.router.navigate([], {
        queryParams: { [this.REI_QUERY_PARAM]: null },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    }

    return detected;
  }
}
